import { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useIsLocal } from '@hooks';
import { Tooltip } from '../Tooltip';
import { TOOLTIP_POSITION } from '@types';
import { Badge } from '../Badge';
import styles from './Link.module.scss';

type LinkPropsT = AnchorHTMLAttributes<HTMLAnchorElement> & {
	domain?: 'eos' | 'spa';
	to: string;
	className?: string;
	count?: number;
	target?: '_blank' | '_self' | '_parent' | '_top'
}

export const Link = (props:PropsWithChildren<LinkPropsT>) => {
	const {
		domain = 'spa',
		to,
		className,
		target,
		children,
		count,
		...otherProps
	} = props;
	const isLocal = useIsLocal();
	let href = to;
	if (isLocal) {
		href = `http://localhost:3000${to}`;
	}
	return (
		<>
			{domain === 'spa' && <RouterLink to={to} className={className ?? styles.link} target={target} {...otherProps}>
				{children}
				{/* Only display the count badge for your-loads/ group-loads when count > 0 */}
				{
					((to.includes('your-loads') || to.includes('group-loads')) && count)
						? <Tooltip position={TOOLTIP_POSITION.RIGHT} text='New loads have been allocated to you in the last 24 hours.'>
							<Badge text={count?.toString() ?? ''} backgroundColor='var(--func-red-default)'/>
						</Tooltip>
						:''
				}
			</RouterLink>}
			{domain === 'eos' && <a href={href} className={className ?? styles.link} target={target} {...otherProps}>
				{children}
			</a>}
		</>
	);
}
